export default __webpack_public_path__ + "static/media/SDG3.6ac976e0.png";